import { WappRoomStatus } from './wapp-room-status'
import { WappRoomListItemTitle } from './wapp-room-list-item-title'
import { MenuIcon } from '$common/icons/menu'
import { nothing } from '$func/utils'
import { useWappRoom } from '$logic/wapp-room/react-hook'
import { ChatListItem } from '$common/room-list-search/chat-list-item'
import { WappAvatar } from '$common/avatar/wapp-avatar'
import { useWapp } from '$logic/wapps/react-hook'
import { AvatarSize } from '$common/avatar/avatar-base/types'

interface Props {
  chatId: string
  hasDivider?: boolean
  onClick?: () => unknown
  onContextMenu?: (e: MouseEvent) => void
  onSecondaryActionIconClick?: () => unknown
  selected?: boolean
}

export function WappRoomListItemWithStatus({
  chatId,
  hasDivider = true,
  onClick = nothing,
  onSecondaryActionIconClick = nothing,
  onContextMenu = nothing,
  selected = false,
}: Props) {
  const { entity: wapRoom } = useWappRoom(chatId)
  const { wappId = '' } = wapRoom || {}
  const { entity: wapp } = useWapp(wappId)
  return (
    <ChatListItem
      avatarComponent={
        <WappAvatar wappId={wappId} selected={selected} size={AvatarSize.MD} />
      }
      verified={wapp?.verified}
      primaryText={<WappRoomListItemTitle wappId={wappId} />}
      secondaryText={<WappRoomStatus />}
      SecondaryActionIcon={MenuIcon}
      hasDivider={hasDivider}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
    />
  )
}
